import { useEffect } from 'react';

export function useTranslationKeyboardShortcut(
  handler: () => void,
  isOpen: boolean
) {
  useEffect(() => {
    const keyboardHandler = function (event: KeyboardEvent) {
      if (event.ctrlKey && event.altKey && event.key === 'h' && !isOpen) {
        handler();
      }
    };
    window.addEventListener('keydown', keyboardHandler);
    return () => window.removeEventListener('keydown', keyboardHandler);
  }, [handler, isOpen]);
}
